/**
 * Utility function to conditionally join CSS class names together
 * @param classes - Array of class names or conditional class names (can include undefined, null, or boolean values)
 * @returns String of joined class names with falsy values filtered out
 */
export function classNames(...classes: (string | boolean | undefined | null)[]) {
  return classes.filter(Boolean).join(" ");
}
